import { AdvisorCreateMessageFormValues } from '../types';
import { useElementsCreateForm, UseElementsCreateFormFormArgs } from '../../../hooks';

export const useAdvisorCreateMessageForm = (args: UseElementsCreateFormFormArgs<AdvisorCreateMessageFormValues>) =>
  useElementsCreateForm<AdvisorCreateMessageFormValues>(args);
